import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";
import { api } from "@/lib/api";

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="pt-40 pb-24 container-page" data-testid="blog-post-not-found">
        <h1 className="font-display font-bold text-3xl">Article introuvable</h1>
        <Link to="/blog" className="mt-6 inline-flex items-center gap-2 copper tech-link">
          <ArrowLeft size={16} /> Retour au journal
        </Link>
      </div>
    );
  }

  if (!post) {
    return <div className="pt-40 pb-24 container-page text-muted-foreground font-mono text-sm">Chargement…</div>;
  }

  return (
    <article className="pt-32 pb-24 bg-background" data-testid="blog-post-page">
      <header className="container-page max-w-3xl">
        <Link to="/blog" className="inline-flex items-center gap-2 overline text-muted-foreground hover:text-foreground tech-link mb-8" data-testid="back-to-blog">
          <ArrowLeft size={14} /> Retour au journal
        </Link>
        <div className="overline copper mb-4">{post.category}</div>
        <h1 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.95]">{post.title}</h1>
        <div className="mt-8 flex items-center gap-6 text-sm font-mono text-muted-foreground border-t border-border pt-6">
          <span>{post.author}</span>
          <span>·</span>
          <span>{new Date(post.published_at).toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" })}</span>
          <span className="inline-flex items-center gap-2"><Clock size={13} /> {post.read_minutes} min</span>
        </div>
      </header>

      <div className="mt-12 container-page max-w-5xl">
        <img src={post.image_url} alt={post.title} className="w-full h-[300px] md:h-[480px] object-cover" />
      </div>

      <div className="container-page max-w-3xl mt-12">
        <div className="prose prose-lg max-w-none">
          {post.content.split("\n\n").map((para, i) => (
            <p key={i} className="text-foreground/85 leading-relaxed mb-6">{para}</p>
          ))}
        </div>

        <div className="mt-16 border-t border-border pt-10 flex items-center justify-between flex-wrap gap-4">
          <Link to="/blog" className="btn-ghost-light" data-testid="back-bottom">
            <ArrowLeft size={16} /> Autres articles
          </Link>
          <Link to="/#contact" className="btn-copper" data-testid="cta-quote-from-blog">
            Demander un devis
          </Link>
        </div>
      </div>
    </article>
  );
}
